import NavCard from "./NavCard";

export default NavCard;
